<template>
  <div class="payment">
    <p class="header">
      {{ title }}
    </p>
    <p class="content content-medium" v-show="type === 1">
      {{ `${currency_now} ${amount_show}` }}
    </p>
    <p class="content content-medium" v-show="type === 2">
      {{ `${prem_currency} ${prem_amout_show}` }}
    </p>
    <div class="content-rate" v-show="showRate">
      <p>{{ equivalenceText }}</p>
      <p class="rate">
        {{ rateText }}
      </p>
    </div>
    <div class="footer">
      <div class="reset" v-show="hasReset">
        <p @click="resetClick">
          {{ $t('reset') }}
        </p>
      </div>
      <div v-if="canModify" class="modify">
        <p @click="modifyClick">
          {{ $t('modify') }}
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import { ExchangeRate } from '@/components'
import utils from '@/utils/utils'
const { addThousands, toFixed, toNum } = utils
const toCeil = (num, s) => toFixed(num, s, 'ceil')
export default {
  props: {
    category: {
      type: [Number, String],
      default: ''
    },
    currency: {
      type: String,
      default: ''
    },
    payamount: {
      type: [Number, String],
      default: 0
    },
    rate: {
      type: Number,
      default: 7.8
    },
    policyno: {
      type: [Number, String],
      default: ''
    },
    types: {
      type: Array,
      default: () => [1, 2]
    },
    needTips: {
      type: Boolean,
      default: false
    },
    minAmount: {
      type: [Number, String],
      default: 0
    },
    maxAmount: {
      type: [Number, String],
      default: 0
    },
    minterms: {
      type: [Number],
      default: 0
    },
    maxterms: {
      type: [Number],
      default: 0
    },
    canModify: {
      type: Boolean,
      default: true
    },
    termsArr: {
      type: Array,
      default: () => []
    },
    flags: {
      type: Object,
      default: () => {
        return {
          HKD: '',
          MOP: '',
          GBP: '',
          USD: '',
          SGD: '',
          RMB: '',
          CAD: '',
          AUD: ''
        }
      }
    },
    isOneMode: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      currency_init: '', // 初始货币
      amount_init: 0, // 初始金额
      currency_now: '', // 当前货币
      amount_now: 0, // 当前金额
      amount_change: 0, // 转换金额
      prem_amout: 0, // 当前金额
      prem_currency: '', // 当前货币
      prem_amout_change: '', // 转换金额
      terms: [],
      cTerms: 0,
      type: 1
    }
  },
  computed: {
    title () {
      return this.$t('paymentAmount')
    },
    rateFixed () {
      return toFixed(this.rate, 5)
    },
    equivalenceText () {
      if (this.type === 1) {
        return this.$t('equivalenceHK') + addThousands(this.iamount_change.toFixed(2))
      } else {
        return this.$t('equivalenceHK') + addThousands(this.prem_amout_change.toFixed(2))
      }
    },
    rateText () {
      return this.$t('rateText')
        .replace('{currency}', this.currency_init)
        .replace('{rate}', this.rateFixed)
    },
    modify () {
      return this.$t('modify')
    },
    showRate () {
      return this.type === 1 ? this.currency_now !== 'HKD' : this.prem_currency !== 'HKD'
    },
    hasReset () {
      if (this.type === 2) return true
      return this.currency_init !== this.currency_now ||
        this.iamount_int !== this.iamount_now
    },
    iamount_int () {
      return toNum(this.amount_init)
    },
    iamount_now () {
      return toNum(this.amount_now)
    },
    iamount_change () {
      return toNum(this.amount_change)
    },
    amount_show () {
      return addThousands(this.amount_now.toFixed(2))
    },
    prem_amout_show () {
      return addThousands(this.prem_amout.toFixed(2))
    },
    byStages () {
      return this.types.indexOf(2) !== -1 && this.policyno
    }
  },
  mounted () {
    this.updated()
  },
  methods: {
    resetClick () {
      this.type = 1
      this.currency_now = this.currency_init
      this.prem_currency = this.currency_init
      this.amount_now = this.amount_init
      this.terms = this.termsArr
      this.amount_change = toCeil(this.amount_now * this.rate, 2)
      this.$emit('onChange', {
        type: this.type,
        currency: this.currency_init,
        payamount: this.iamount_int,
        equalHKAmount: this.currency_init === 'HKD'
          ? this.iamount_int : this.iamount_change
      })
    },
    modifyClick () {
      this.openExchangeRate()
    },
    openExchangeRate () {
      ExchangeRate({
        type: this.type,
        types: this.types,
        iCurrency: this.currency_now,
        dCurrency: this.currency_init,
        nCurrency: this.prem_currency,
        payamount: this.amount_now,
        tpayamount: this.amount_change,
        minAmount: this.minAmount,
        maxAmount: this.maxAmount,
        rate: this.rate,
        minterms: this.minterms,
        maxterms: this.maxterms,
        cTerms: this.cTerms,
        terms: this.terms,
        flags: this.flags,
        needTips: this.needTips,
        isOneMode: this.isOneMode
      })
        .then(data => {
          this.type = data.type
          if (data.type === 1) {
            this.currency_now = data.currency
            this.amount_now = data.payamount
            this.amount_change = data.ex_payamount
          } else {
            this.prem_amout = data.payamount
            this.prem_amout_change = data.ex_payamount
            this.prem_currency = data.currency
            this.terms = data.terms.slice()
            this.cTerms = data.cTerms
          }
          this.$emit('onChange', {
            type: this.type,
            currency: data.currency,
            payamount: data.payamount,
            equalHKAmount: data.currency === 'HKD'
              ? data.payamount : data.ex_payamount
          })
        })
        .catch(() => {})
    },
    updated () {
      this.currency_now = this.currency
      this.currency_init = this.currency
      this.amount_now = toNum(this.payamount)
      this.amount_init = toNum(this.payamount)
      this.amount_change = toCeil(this.amount_now * this.rate, 2)
      this.prem_currency = this.currency
      this.cTerms = this.minterms
      this.terms = this.termsArr
      setTimeout(() => {
        this.resetClick()
      }, 0)
    },
    updateAmount (data) {
      this.currency_now = data.currency
      this.currency_init = data.currency
      this.amount_now = toNum(data.payamount)
      this.amount_init = toNum(data.payamount)
      this.amount_change = toCeil(data.amount_now * data.rate, 2)
      this.prem_currency = data.currency
      this.cTerms = data.minterms
      this.terms = data.termsArr
      setTimeout(() => {
        this.resetClick()
      }, 0)
    }
  }
}
</script>

<style lang="scss" scoped>
.payment {
  padding: 25px;
  background-color: $color-bg-white;
  p {
    text-align: center;
  }
  p.header {
    margin-bottom: 10px;
    color: $color-text;
    font-size: $base-font-size;
    line-height: 22px;
  }
  p.content {
    margin-bottom: 10px;
    color: $color-text;
    font-size: $large-font-size;
    line-height: 37px;
  }
  p.content-medium {
    @include font-Medium;
  }
  .content-rate {
    position: relative;
    padding-top: 15px;
    @include border-top;
    p {
      color: $color-stage5;
      font-size: $span-font-size;
      line-height: 20px;
    }
    p.rate {
      font-size: $little-font-size;
      line-height: 16.8px;
      transform: scale(0.833);
    }
  }
  .footer {
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-top: 19px;
    .reset,
    .modify {
      height: 20px;
      p {
        padding: 0 40px;
        color: $color-primary;
        font-size: $span-font-size;
        line-height: 20px;
      }
    }
    .reset {
      @include border-right(2px);
    }
  }
}
</style>
